import { requestGet, requestPost } from '@/utils/request'

export function commentAdd(params){
  return requestPost('/person/comment/add', params);
}
